import React from 'react'

import {
    StyledListItem,
    StyledOrderedList,
    StyledUnorderedList,
} from 'component-library/typography/List/List.styled'
import { OnEventHandler } from 'component-library/typography/TextItem/TextItem'
import { TextBlock } from 'common/client-data-types/blocks'

export interface Props {
    items: TextBlock[]
    listType: 'ol' | 'ul'
    onEvent: OnEventHandler
}

export const List: React.FC<Props> = props => {
    const ListItems = props.items.map<JSX.Element>((listItem, index) => {
        return (
            <StyledListItem
                key={index}
                intentions={listItem.intentions}
                text={listItem.text}
                tag="li"
                onEvent={props.onEvent}
            />
        )
    })

    const ListType =
        props.listType === 'ol' ? (
            <StyledOrderedList>{ListItems}</StyledOrderedList>
        ) : (
            <StyledUnorderedList>{ListItems}</StyledUnorderedList>
        )

    return ListType
}
List.displayName = 'List'
